"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveReadReceiptOption')(function saveReadReceiptOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, optionId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.ReadReceipt = optionState.readReceiptResponse;
                    switch (optionState.readReceiptResponse) {
                        case 'DoNotAutomaticallySend':
                            optionId = 0;
                            break;
                        case 'AlwaysSend':
                            optionId = 1;
                            break;
                        case 'NeverSend':
                            optionId = 2;
                            break;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration({
                            ReadReceiptResponse: optionId,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveReadReceiptOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-read-receipts-option/lib/actions/saveReadReceiptOption.js
// module id = 5060
// module chunks = 2